import React, { useState } from "react";
import DefaultViewSkeleton from "Components/Generic/SideView/Skeleton";

import {
  MainContainer,
  MainContainerSidebar,
  FeatureLockedContainer,
  FeatureLockedContainerSidebar,
  FeatureLockedCard,
  FeatureLockedCardSidebar,
  ContactSupportContainer,
  RocketGif,
  TitleText,
  DescriptionText,
  DescriptionSupportText,
  ContactSupportContainerSidebar,
} from "./styles";
import { useTranslation } from "react-i18next";
import { SupportSendRequestPopup } from "./SendRequestSupport";

interface FeatureLockedProps {
  featureLabel: string;
  variant?: "page" | "sidebar";
}

const rocket = require("Assets/gifs/rocket.gif");

const FeatureLocked = ({ featureLabel, variant = "page" }: FeatureLockedProps) => {
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

  const { t } = useTranslation();

  const handleOpenModal = () => {
    setIsOpenModal(true);
  };

  const handleCloseModal = () => {
    setIsOpenModal(false);
  };

  return (
    <div>
      {variant === "sidebar" ? (
        <MainContainerSidebar>
          <FeatureLockedContainerSidebar>
            <FeatureLockedCardSidebar>
              <RocketGif src={rocket} alt="Rocket illustration" />
              <TitleText>{t("featureLocked")}</TitleText>
              <DescriptionText>{t("accountNotHaveAccess")}</DescriptionText>
              <ContactSupportContainerSidebar>
                <DescriptionSupportText onClick={() => handleOpenModal()}>
                  {t("reachSupportTeam")}&nbsp;{t("forDetails")}
                </DescriptionSupportText>
              </ContactSupportContainerSidebar>
            </FeatureLockedCardSidebar>
          </FeatureLockedContainerSidebar>
          <SupportSendRequestPopup
            isOpen={isOpenModal}
            feature={featureLabel}
            onClose={() => {
              handleCloseModal();
            }}
          />
        </MainContainerSidebar>
      ) : (
        <MainContainer>
          <DefaultViewSkeleton />
          <FeatureLockedContainer>
            <FeatureLockedCard>
              <RocketGif src={rocket} alt="Rocket illustration" />
              <TitleText>{t("featureLocked")}</TitleText>
              <DescriptionText>{t("accountNotHaveAccess")}</DescriptionText>
              <ContactSupportContainer>
                <DescriptionSupportText onClick={() => handleOpenModal()}>
                  {t("reachSupportTeam")}
                </DescriptionSupportText>
                <DescriptionText>&nbsp;{t("forDetails")}</DescriptionText>
              </ContactSupportContainer>
            </FeatureLockedCard>
          </FeatureLockedContainer>

          <SupportSendRequestPopup
            isOpen={isOpenModal}
            feature={featureLabel}
            onClose={() => {
              handleCloseModal();
            }}
          />
        </MainContainer>
      )}
    </div>
  );
};

export default FeatureLocked;
